import { createClient } from '@supabase/supabase-js';

const supabaseUrl = import.meta.env.VITE_SUPABASE_URL;
const supabaseAnonKey = import.meta.env.VITE_SUPABASE_ANON_KEY;

if (!supabaseUrl) {
  throw new Error('Missing VITE_SUPABASE_URL environment variable');
}

if (!supabaseAnonKey) {
  throw new Error('Missing VITE_SUPABASE_ANON_KEY environment variable');
}

export const supabase = createClient(supabaseUrl, supabaseAnonKey, {
  auth: {
    autoRefreshToken: true,
    persistSession: true,
    detectSessionInUrl: true
  },
  global: {
    headers: {
      'Content-Type': 'application/json'
    }
  }
});

// Test connection and log detailed error information
const testConnection = async () => {
  try {
    const { data, error, status } = await supabase
      .from('practitioners')
      .select('id')
      .limit(1)
      .maybeSingle();

    if (error) {
      console.error('Supabase connection error:', {
        message: error.message,
        details: error.details,
        hint: error.hint,
        code: error.code,
        status
      });
      return false;
    }

    console.log('Successfully connected to Supabase');
    return true;
  } catch (error: any) {
    console.error('Failed to connect to Supabase:', {
      message: error.message,
      status: error?.status,
      statusText: error?.statusText,
      stack: error?.stack
    });
    return false;
  }
};

// Create a connection monitor
let connectionTestInterval: number;

const startConnectionMonitoring = () => {
  // Test immediately
  testConnection();
  
  // Then test every 30 seconds
  connectionTestInterval = window.setInterval(testConnection, 30000);
};

// Start monitoring
startConnectionMonitoring();

// Cleanup function
export const cleanup = () => {
  if (connectionTestInterval) {
    clearInterval(connectionTestInterval);
  }
};